// @flow
import React from 'react'
import './styles.scss'
// https://reactjsexample.com/a-very-simple-echarts-wrapper-for-react/
import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'

const isMobile = window.innerWidth < 650

export class GlobalCo2 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800,
      chartOptions: {},
      echartInstance: null
    }
    /*
    this.handleEvents = {
      mouseover: this.onChartHover,
      mouseout: this.onChartLeave
    }
    */
  }

  /*
  onChartHover = params => {
    // console.log('+++++ params ++++')
    // console.log(params)

    // highlight the hovered series
    this.state.echartInstance.setOption(this.getOption(params.seriesIndex))
  }

  onChartLeave = params => {
    // console.log('+++++ params ++++')
    // console.log(params)
    if (params.color === this.props.lineColors.highlight) {
      this.state.echartInstance.setOption(this.getOption(-1))
    }
  }
  */

  componentDidMount() {
    this.setState(
      {
        chartOptions: this.getOption()
      },
      () => {
        this.setState({
          echartInstance: this.echarts_react.getEchartsInstance()
        })
      }
    )
  }

  /*
  getAllConcentrations(data) {
    // console.log('data', data)
    // console.log('highlightIndex', highlightIndex)

    const seriesData = []

    const AllAnomalies = data.map(function(currYear, index) {
      // console.log('currYear', currYear)
      // return data for year
      return currYear.concentration
    })

    // add markline at 0

    // console.log('AllAnomalies')
    // console.log(AllAnomalies)
    // return AllAnomalies
    seriesData.push({
      name: 'CO₂-Konzentration',
      type: 'line',
      color: this.props.lineColors.past,
      lineStyle: {
        opacity: 0.6
      },
      showSymbol: false,
      symbolSize: 6,
      itemStyle: {
        borderWidth: 2,
        opacity: 1
      },
      connectNulls: true,
      silent: false,
      animation: false,
      data: AllAnomalies
    })

    // add markline at 0
    const baseline = {
      name: 'baseline',
      type: 'line',
      color: '#FFFFFF',
      data: [0],
      silent: true,
      z: 2,
      markLine: {
        data: [
          {
            name: 'baseline',
            yAxis: 0
          }
        ],
        lineStyle: {
          type: 'solid'
        },
        symbol: false,
        symbolSize: 0,
        animation: false
      }
    }
    seriesData.push(baseline)
    */

  // add month marks at the bottom
  /*
    const allMonths = this.getAllYears(this.props.data)
    const monthMarks = {
      name: 'monthMarks',
      type: 'line',
      color: '#8e8e8e',
      data: [0],
      silent: true,
      z: 1,
      markLine: {
        data: [
          {
            name: '190001',
            xAxis: allMonths.indexOf('190001')
          },
          {
            name: '193001',
            xAxis: allMonths.indexOf('193001')
          },
          {
            name: '196001',
            xAxis: allMonths.indexOf('196001')
          },
          {
            name: '199001',
            xAxis: allMonths.indexOf('199001')
          },
          {
            name: '202001',
            xAxis: allMonths.indexOf('202001')
          }
        ],
        lineStyle: {
          type: 'dotted',
          opacity: 0.3
        },
        label: {
          show: false
        },
        symbol: false,
        symbolSize: 0,
        animation: false
      }
    }
    seriesData.push(monthMarks)
    */

  /*
    return seriesData
  }
  */

  /*
  getAllYears(data) {
    const AllYears = data.map(function(currYear, index) {
      console.log('currYear', currYear.Year)
      return currYear.Year
    })

    console.log('AllYears', AllYears)
    return AllYears
  }
  */

  // Chart Options
  // https://ecomfe.github.io/echarts-doc/public/en/option.html#title
  getOption = () => ({
    title: {
      text: '',
      subtext: ''
    },
    tooltip: {
      axisPointer: {
        snap: true,
        type: 'line'
      },
      trigger: 'axis',
      textStyle: {
        color: '#333'
      },
      backgroundColor: '#f3f3f3',
      formatter: function(params, ticket, callback) {
        // console.log('#### params ####', params)
        // console.log('#### data ####', this.props.data)
        const currYear = params[0].axisValue

        // negative value?
        let formattedYear = currYear < 0 ? -currYear : currYear

        // add apostrophs?
        formattedYear =
          formattedYear.toString().length > 5
            ? formattedYear
                .toString()
                .match(/.{3}/g)
                .join("'")
            : formattedYear.toString().length > 4
            ? [
                formattedYear.toString().slice(0, 2),
                "'",
                formattedYear.toString().slice(2)
              ].join('')
            : formattedYear.toString()
        formattedYear =
          currYear < 0 ? formattedYear + ' v. Chr.' : formattedYear

        const currConcentration = parseFloat(params[0].data.value[1])
        const title =
          '<div class="tip-title"><strong>' + formattedYear + '</strong></div>'
        let tooltipContent = title + '<hr class="under" />'
        tooltipContent += '<div class="row">'
        tooltipContent += 'Konzentration: '
        tooltipContent +=
          '<span class="weighted">' + currConcentration + ' ppm</span></div>'
        // callback(console.log('scrubbed to: ', params[0].dataIndex))

        return tooltipContent
      }
    },
    dataZoom: [
      {
        type: 'slider',
        xAxisIndex: 0,
        filterMode: 'empty',
        showDataShadow: false,
        minValueSpan: 20,
        bottom: 35,
        height: 10,
        left: 70,
        right: 20,
        borderColor: 'transparent',
        backgroundColor: '#222222',
        handleIcon: 'image://' + require('./images/handle.svg'),
        handleSize: 20,
        labelFormatter: '',
        labelPrecision: 10
      }
    ],
    grid: [
      {
        top: this.state.isMobile ? '5%' : '5%',
        left: 4,
        right: 12,
        bottom: 10,
        containLabel: true
      }
    ],
    xAxis: {
      type: 'value',
      min: 'dataMin',
      max: 'dataMax',
      boundaryGap: false,
      z: 2,
      // data: this.state.dummyYears, // this.getAllYears(this.sprops.data),
      axisLine: {
        lineStyle: {
          color: ['#fff']
        }
      },
      splitLine: {
        lineStyle: {
          color: ['#fff'],
          type: 'dotted',
          opacity: 0.1
        }
      },
      axisLabel: {
        textStyle: {
          color: '#fff'
        },
        fontSize: this.state.isMobile ? 10 : 12,
        formatter: function(value, index, callback) {
          // negative value?
          let formattedValue = value < 0 ? -value : value

          // add apostrophs?
          formattedValue =
            formattedValue.toString().length > 5
              ? formattedValue
                  .toString()
                  .match(/.{3}/g)
                  .join("'")
              : formattedValue.toString().length > 4
              ? [
                  formattedValue.toString().slice(0, 2),
                  "'",
                  formattedValue.toString().slice(2)
                ].join('')
              : formattedValue.toString()
          return value < 0
            ? isMobile
              ? formattedValue + '\n v. Chr.'
              : formattedValue + ' v. Chr.'
            : formattedValue
        }
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: ['#727272']
        },
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        formatter: function(value, index, callback) {
          return value > 0 ? value + ' ppm' : ''
        },
        textStyle: {
          color: '#fff'
        }
      }
    },
    series: [
      {
        name: 'Konzentration',
        type: 'line',
        color: this.props.lineColors.past,
        lineStyle: {
          width: 1
        },
        showSymbol: false,
        hoverAnimation: false,
        data: this.props.data,
        silent: true,
        z: 99,
        markPoint: {
          data: [
            {
              name: 'aktuell',
              symbol: 'circle',
              symbolSize: 5,
              value: this.props.data[this.props.data.length - 1].value[0],
              xAxis: 'max',
              yAxis: 'max',
              itemStyle: {
                color: this.props.lineColors.past,
                borderColor: this.props.lineColors.current,
                borderWidth: 2
              },
              label: {
                color: '#ffffff',
                fontSize: 14,
                offset: [-25, 0]
              }
            }
          ]
        }
      }
    ]
  })

  render() {
    // console.log('### DATA ###', this.props.data)
    // register theme object
    // theme object format example: https://github.com/apache/incubator-echarts/blob/master/theme/dark.js
    echarts.registerTheme('ta_theme', {
      backgroundColor: 'transparent',
      textStyle: {
        fontSize: '16',
        fontFamily:
          'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
        color: '#333'
      },
      title: {
        textStyle: {
          color: '#333',
          fontSize: '22'
        },
        subtextStyle: {
          color: '#5f5f5f',
          fontSize: '18'
        }
      },
      legend: {
        left: 'left',
        orient: 'vertical',
        itemGap: 7,
        padding: [0, 0, 0, 10],
        itemWidth: 10,
        textStyle: {
          fontSize: '16'
        },
        show: false
      },
      label: {
        show: false
      },
      smooth: true
    })

    return (
      <div className='echart monthly-anomaly'>
        <h3>{this.props.title}</h3>
        <h5>{this.props.subtitle}</h5>
        <ReactEcharts
          ref={e => {
            this.echarts_react = e
          }}
          onEvents={this.handleEvents}
          option={this.state.chartOptions}
          opts={{ renderer: 'canvas' }}
          notMerge
          lazyUpdate
          theme='ta_theme'
          style={{ height: this.state.isMobile ? '20em' : '23em' }}
        />
        <div className='source'>Quelle: EPICA Dome C CO₂ record, NOAA</div>
      </div>
    )
  }
}
